exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auto-dialer--LKkVDkT1c7t-KgbeEP7oO {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  padding: 0 24px;\n}\n", ""]);

// exports
exports.locals = {
	"autoDialerContainer": "auto-dialer--LKkVDkT1c7t-KgbeEP7oO",
	"autoDialerContainer": "auto-dialer--LKkVDkT1c7t-KgbeEP7oO"
};